import { apiSlice } from '../api/apiSlice';
import {
  ChangePasswordParams,
  Profile,
  setPasswordParams,
} from './profileApiSliceTypes';

const profileApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUserProfile: builder.query<Profile, void>({
      query: () => ({
        url: '/profile',
        method: 'GET',
      }),
    }),

    updateProfile: builder.mutation({
      query: (params) => ({
        url: '/profile',
        method: 'PATCH',
        headers: {
          'Accept-Language': params.language || 'en',
        },
        body: {
          fullName: params.fullName,
          phoneNumber: params.phoneNumber,
          language: params.language || 'en',
          defaultCurrency: params.defaultCurrency || 'usd',
          country: params.country,
        },
      }),
    }),

    changePassword: builder.mutation<void, ChangePasswordParams>({
      query: (params) => ({
        url: '/profile/change-password',
        method: 'PATCH',
        body: {
          oldPassword: params.oldPassword,
          newPassword: params.newPassword,
        },
      }),
    }),

    setPassword: builder.mutation<void, setPasswordParams>({
      query: (params) => ({
        url: '/profile/set-password',
        method: 'POST',
        body: {
          password: params.password,
        },
      }),
    }),

    deleteAccount: builder.mutation<void, void>({
      query: () => ({
        url: '/profile',
        method: 'DELETE',
      }),
    }),
  }),

  overrideExisting: true,
});

export const {
  useGetUserProfileQuery,
  useUpdateProfileMutation,
  useChangePasswordMutation,
  useSetPasswordMutation,
  useDeleteAccountMutation,
  useLazyGetUserProfileQuery,
} = profileApiSlice;
